"use client";

import Typewriter from "typewriter-effect";

const TypewriterDemo = ({ strings }: { strings: string[] }) => {
  return (
    <Typewriter
      options={{
        strings: strings,
        autoStart: true,
        loop: true,
      }}
    />
  );
};

export default TypewriterDemo;
